<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="aubio"><a class="page" id="piv"></a><b>Sharon R. Krause</b> is professor in and chair of the Department of Political Science at Brown University. She is the author of <i>Civil Passions</i> and <i>Liberalism with Honor</i>.</p>
<p class="crtf">The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2015 by The University of Chicago</p>
<p class="crt">All rights reserved. Published 2015.</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">24 23 22 21 20 19 18 17 16 15   1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-23469-4 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-23472-4 (e-book)</p>
<p class="crt">DOI: 10.7208/chicago/9780226234724.001.0001</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Krause, Sharon R., author.</p>
<p class="cip"> Freedom beyond sovereignty : reconstructing liberal individualism / Sharon R. Krause.</p>
<p class="cip">   pages cm</p>
<p class="cip"> Includes bibliographical references and index.</p>
<p class="cip"> ISBN 978-0-226-23469-4 (cloth : alkaline paper) — ISBN 978-0-226-23472-4 (e-book) 1. Individualism—United States. 2. Liberalism—United States. 3. Agent (Philosophy) I. Title.</p>
<p class="cip"> JC574.2.U6K74 2015</p>
<p class="cip"> 320.510973—dc23</p>
<p class="cip">	2014025468</p>
<p class="crtf">♾ This paper meets the requirements of ANSI/NISO Z39.48–1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-krause-0004.vue?6b22262f